import { Component, OnInit, ViewChild, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileUtil } from 'src/app/objects/fileUtil';
import { EventService } from 'src/app/services/event.service';
import { GGKResponse } from 'src/app/objects/ggkResponse';

@Component({
  selector: 'ggk-upload-points',
  templateUrl: './upload-points.component.html',
  styleUrls: ['./upload-points.component.scss']
})
export class UploadPointsDialogComponent implements OnInit {
  @ViewChild('file') fileInput;

  group_event_id: string;
  group_id: string;
  statusText: string;
  loading: boolean = false;
  cancel: boolean = false;
  loadingComplete: boolean = false;
  addPoints: boolean = false;

  @Output() addComplete = new EventEmitter<string>();

  uploading: boolean = false;
  fileToUpload: File;
  fileName: string;
  fullCsvRecords = [];

  constants: any = {
    tokenDelimeter: ",",
    isHeaderPresentFlag: true,
    validateHeaderAndRecordLengthFlag: true,
    valildateFileExtenstionFlag: true
  }

  constructor(
    private eventService: EventService,
    private dialog: MatDialog,
    private fileUtil: FileUtil,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.group_event_id = data.group_event_id;
    this.group_id = data.group_id;
  }

  ngOnInit() {
  }

  getFileName() {
    if (this.fileName) {
      return this.fileName;
    }
    return "Select a File!"
  }

  showFilePicker() {
    this.fileInput.nativeElement.click();
  }

  fileSelected() {
    return this.fileInput.nativeElement.files && this.fileInput.nativeElement.files.lenght > 0;
  }

  loadPoints() {
    this.loading = true;
    //file will have a header, start at 1
    var playersAndPoints = [];
    debugger;
    for (var i = 1; i < this.fullCsvRecords.length; i++) {
      var playerPoints = [];
      playerPoints.push(this.fullCsvRecords[i][0]);//player_id
      playerPoints.push(this.fullCsvRecords[i][3]);//player_points
      playerPoints.push(this.fullCsvRecords[i][4]);//reason
      playersAndPoints.push(playerPoints.join(':'));
    }

    this.eventService.loadEventPoints(this.group_id, this.group_event_id, this.addPoints, playersAndPoints.join(','))
      .subscribe(resp => {
        var response: GGKResponse = JSON.parse(resp.d);
        console.log(response);
        this.loading = false;
        this.loadingComplete = true;
        if (response.status == 0)
          this.statusText = response.data;
        else
          this.statusText = "Points uploaded Successfully!";
      });

  }

  closeDialog() {
    this.fileReset();
    this.dialog.closeAll();
  }

  saveFile() {
    //no-op;
  }

  fileReset() {
    this.fileInput.nativeElement.value = "";
    this.fullCsvRecords = [];
    this.fileName = '';
    this.loadingComplete = false;
  }

  fileChangeListener($event): void {
    var text = [];
    var files = $event.srcElement.files;
    console.log(files[0]);
    this.fileName = files[0].name;

    if (this.constants.validateHeaderAndRecordLengthFlag) {
      if (!this.fileUtil.isCSVFile(files[0])) {
        alert("Please import valid .csv file.");
        this.fileReset();
      }
    }

    var input = $event.target;
    var reader = new FileReader();
    reader.readAsText(input.files[0]);

    reader.onload = (data) => {
      let csvData: string = reader.result.toString();
      let csvRecordsArray = csvData.split(/\r\n|\n/);

      var headerLength = -1;
      if (this.constants.isHeaderPresentFlag) {
        let headersRow = this.fileUtil.getHeaderArray(csvRecordsArray, this.constants.tokenDelimeter);
        headerLength = headersRow.length;
      }

      this.fullCsvRecords = this.fileUtil.getDataRecordsArrayFromCSVFile(csvRecordsArray,
        headerLength, this.constants.validateHeaderAndRecordLengthFlag, this.constants.tokenDelimeter);

      console.log(this.fullCsvRecords);
      if (this.fullCsvRecords == null) {
        //If control reached here it means csv file contains error, reset file.
        this.fileReset();
      }
    }

    reader.onerror = function () {
      alert('Unable to read ' + input.files[0]);
    };
  }

}
